var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$route.query.confirmSucessful
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "confirm-together",
              staticStyle: { "margin-bottom": "1.5rem", "margin-top": "2rem" }
            },
            [
              _c("p", {
                staticStyle: { display: "inline-block" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("signup.ok", {
                      email:
                        "<span style='color:#3238C4'>" +
                        _vm.$route.query.email +
                        "</span>"
                    })
                  )
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "1.5rem" } }, [
            _c("h6", [_vm._v(_vm._s(_vm.$t("signup.modal3")))])
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "1.5rem" } }, [
            !_vm.inOpenlegal()
              ? _c("h6", {
                  staticStyle: { display: "inline-block" },
                  domProps: { innerHTML: _vm._s(_vm.$t("signup.modal4")) }
                })
              : _c("h6", {
                  staticStyle: { display: "inline-block" },
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("signup.modal4-openlegal"))
                  }
                })
          ])
        ])
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("account.confirm-account-error")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e14dac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e14dac2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/RegisterPostScreen.vue
// module id = 4290
// module chunks = 95